export enum UIArtefaktTyp {
  INTEGER = 'Integer',
  DOUBLE = 'Double',
  PROZENT = 'Prozent',
  PROZENT_DOUBLE = 'ProzentDouble',
  DATE = 'Date',
  BLOCK = 'Block',
  BOOLEAN = 'Boolean',
  SELECTION_BOOLEAN = 'SelectionBoolean',
  BUTTON = 'Button',
  ACTION_BUTTON = 'ActionButton',
  WERTEMENGE = 'Wertemenge',
  ARTEFAKT_GRUPPE = 'ArtefaktGruppe',
  MENU_GRUPPE = 'MenuGruppe',
  MENU_SEITE = 'MenuSeite',
  TABELLE = 'Tabelle',
  TABELLENKOPF = 'Tabellenkopf',
  TABELLENFUSS = 'Tabellenfuss',
  TABELLENINHALT = 'Tabelleninhalt',
  FLIESSTEXT = 'Fliesstext',
  ABSATZ = 'Absatz',
  TELEFONNUMMER = 'Telefonnummer',
  UIVORGANG_REFERENZ = 'UIVorgangReferenz',
  UI_PLATZHALTER = 'UIPlatzhalter',
  TEXTFELD = 'Textfeld',
  RISIKOSUCHFRAGE = 'Risikosuchfrage',
  SYMBOL = 'Symbol',
  UI_CONTAINER = 'UIContainer',
  LISTE = 'Liste',
  LISTENELEMENT = 'Listenelement',
  DIVIDER = 'Divider',
  MODUL = 'Modul',
  VERMITTLERNUMMER = 'Vermittlernummer',
  ADRESSVORSCHLAG = 'Adressvorschlag',
  ROETELN = 'Roeteln',
  WERTEMENGE_KDB_ABFRAGE = 'WertemengeKundendatenbankAbfrage',
  ZEITRAUM = 'Zeitraum',
  UEBERSICHT_FONDSANALGE = 'UebersichtFondsanlage',
  UEBERSICHT_FONDSANLAGE_OPTIONEN = 'UebersichtFondsanlageOptionen',
  UEBERSICHT_FONDSANLAGE_ZUZAHLUNG = 'UebersichtFondsanlageZuzahlung',
  UEBERSICHT_FONDSANLAGE_ABLAUFMANAGEMENT = 'UebersichtFondsanlageAblaufmanagement',
  UEBERSICHT_FONDSANLAGE_ANLAUFMANAGEMENT = 'UebersichtFondsanlageAnlaufmanagement'
}
